import script from "./SubastaLotesList.vue?vue&type=script&setup=true&lang=js"
export * from "./SubastaLotesList.vue?vue&type=script&setup=true&lang=js"

import "./SubastaLotesList.vue?vue&type=style&index=0&id=c7bf7b6a&lang=css"

const __exports__ = script;

export default __exports__